module.exports = __webpack_public_path__ + "static/media/white-contour-pattern.397ccc96.jpg";